import React, { useState, useEffect, useContext } from "react"
import { Table, Form } from "react-bootstrap"
import "./ListadoCohortes.css"
import Loading from "../Utils/Loading"
import MenuCohorte from "../Utils/MenuCohorte"
import NombreCohorte from "../Utils/NombreCohorte"
import UAI from "../UAI"
import Atributo from "../Utils/Atributo"
import ImportarAtributos from "./ImportarAtributos"
import { UsuarioContext } from "../Context/Usuario"
import EditarCohorteModal from "./EditarCohorteModal"
import { Link } from "react-router-dom"
import styles from "../Utils/Styles"
import log from "loglevel"

/**
 * Listado de cohortes con atributos variables
 * @param {Object} props
 * @returns
 */
const ListadoCohortes = (props) => {
  const { usuario, setUsuario } = useContext(UsuarioContext)

  const [multiselectCohortes, setMultiselectCohortes] = useState([])
  const [selectedCohorte, setSelectedCohorte] = useState(null)
  const [isOpenEditarEnLinea, setIsOpenEditarEnLinea] = useState(false)
  const [cohortes, setCohortes] = useState(null)
  const [fields, setFields] = useState(null)
  const [tienePermisoEditarPagina, setTienePermisoEditarPagina] = useState(null)

  const abrirEditarEnLinea = (cohortes) => {
    log.debug("OK!")
    setMultiselectCohortes(cohortes)
    setIsOpenEditarEnLinea(true)
  }

  const cerrarEditarEnLinea = (cohorte) => {
    setIsOpenEditarEnLinea(false)
  }

  useEffect(() => {
    log.debug("UseEffect Listado cohortes!")

    const filtroPendientesVista = (cohorte) => {
      let _visible = false
      if (!cohorte.Periodo) {
        return false
      }
      props.view.fields.forEach((field) => {
        if (
          cohorte[field] === undefined ||
          cohorte[field] === null ||
          cohorte[field] === ""
        ) {
          _visible = true
          return
        }
      })
      return _visible
    }

    const filtroFacultadUnidadVenta = (cohorte) => {
      let facultad = UAI.obtieneFacultadPorNombrecorto(props.tabs.facultad)
      let unidadventa = UAI.obtieneUnidadVentaPorNombrecorto(
        props.tabs.unidadventa
      )
      let ok =
        facultad.id === cohorte.FacultadId &&
        cohorte.unidadesventa.indexOf(unidadventa.key) >= 0
      return ok
    }

    setCohortes(null)
    //Cargaremos los cohortes del usuario a partir de los parámetros de Unidad de Venta
    let cohortesusuario = props.cohortes
    let facultad = props.tabs.facultad
    let unidadventa = props.tabs.unidadventa
    if (unidadventa && facultad) {
      if (facultad === "resumen") {
        facultad = Object.keys(usuario.facultades)[0]
      }
    } else {
      throw new Error(
        "Datos inválidos! No existen cohortes para esta vista:" +
          facultad +
          "-" +
          unidadventa
      )
    }
    // Filtramos los cohortes por facultad y unidad de venta
    cohortesusuario = Object.entries(cohortesusuario)
      .map(([key, value]) => value)
      .filter(filtroFacultadUnidadVenta)
    // Solo mostramos los cohortes que son del período
    let listadoCohortes = props.filtroVista
      ? cohortesusuario.filter(filtroPendientesVista)
      : cohortesusuario
    if (props.view.filtroCohortes) {
      listadoCohortes = listadoCohortes.filter(props.view.filtroCohortes)
    }
    let filtroBorradores = props.borradores || props.view.borradores
    if (filtroBorradores) {
      listadoCohortes = listadoCohortes.filter((coh) => {
        return (
          (filtroBorradores === "noborradores" && !coh.esborrador) ||
          (filtroBorradores === "soloborradores" && coh.esborrador) ||
          filtroBorradores === "todo"
        )
      })
    }
    // Si la vista tiene un filtro de exclusión, lo aplicamos
    if (props.view.excluir) {
      let prev = listadoCohortes.length
      listadoCohortes = listadoCohortes.filter((coh) => {
        return props.view.excluir.grados.indexOf(coh.gradoid) < 0
      })
      console.log(
        "Filtro de vista aplicado " + prev + " -> " + listadoCohortes.length
      )
    }
    let index = props.tabs.facultad + "-" + props.tabs.unidadventa
    if (
      props.tabs.activeFilters &&
      props.tabs.activeFilters[index] &&
      props.tabs.activeFilters[index].coordinadorasadmision &&
      props.tabs.activeFilters[index].coordinadorasadmision.length > 0
    ) {
      listadoCohortes = listadoCohortes.filter((c) => {
        return (
          props.tabs.activeFilters[index].coordinadorasadmision.indexOf(
            c.usuario_coordinador_admision
          ) >= 0
        )
      })
    }
    if (
      props.tabs.activeFilters &&
      props.tabs.activeFilters[index] &&
      props.tabs.activeFilters[index].coordinadorasprogramas &&
      props.tabs.activeFilters[index].coordinadorasprogramas.length > 0
    ) {
      listadoCohortes = listadoCohortes.filter((c) => {
        return (
          props.tabs.activeFilters[index].coordinadorasprogramas.indexOf(
            c.coordinador_academico
          ) >= 0
        )
      })
    }
    // Filtramos por fecha de inicio si es que el filtro está activo
    if (
      props.tabs.activeFilters &&
      props.tabs.activeFilters[index] &&
      props.tabs.activeFilters[index].fechainicio &&
      props.tabs.activeFilters[index].fechainicio.start &&
      props.tabs.activeFilters[index].fechainicio.end
    ) {
      listadoCohortes = listadoCohortes.filter((c) => {
        return (
          props.tabs.activeFilters[index].fechainicio.start < c.fechainicio &&
          props.tabs.activeFilters[index].fechainicio.end > c.fechainicio
        )
      })
    }
    // Ordenamos el listado de cohortes por año inicio, grado y nombre
    listadoCohortes.sort(function (a, b) {
      let sa =
        (a.esborrador ? "Z" : "A") +
        a.año_inicio +
        "-" +
        UAI.nombresGrados[a.gradoid] +
        "-" +
        a.nombre
      let sb =
        (b.esborrador ? "Z" : "A") +
        b.año_inicio +
        "-" +
        UAI.nombresGrados[b.gradoid] +
        "-" +
        b.nombre
      return sb.localeCompare(sa)
    })
    // Armamos el arreglo de atributos que se mostrará en el listado
    let fieldstmp = []
    let permiso = UAI.obtienePermisoEdicionVista(usuario, props.view)
    props.tabs.columns[props.view.key].forEach((field) => {
      let atributo = usuario.atributos[field]
      if (!atributo) {
        log.error("ERROR GRAVE! Atributo no existe:" + field)
      } else {
        if (atributo.editable) {
          permiso = true
        }
        fieldstmp.push(atributo)
      }
    })
    if (props.deshabilitarEdicion) {
      permiso = false
    }
    setCohortes(listadoCohortes)
    setFields(fieldstmp)
    setTienePermisoEditarPagina(permiso)
  }, [
    props.deshabilitarEdicion,
    props.tabs.activeFilters,
    props.view,
    props.tabs.facultad,
    props.tabs.unidadventa,
    props.tabs.columns,
    usuario,
  ])

  const selectAllNone = () => {
    if (multiselectCohortes.length < cohortes.length) {
      let newMultiselect = []
      for (let id in cohortes) {
        let cohorte = cohortes[id]
        if (newMultiselect.indexOf(cohorte.id) < 0) {
          newMultiselect.push(cohorte.id)
        }
      }
      setMultiselectCohortes(newMultiselect)
    } else {
      setMultiselectCohortes([])
    }
  }

  const cohorteSelected = (element) => {
    let newMultiselect = JSON.parse(JSON.stringify(multiselectCohortes))
    if (newMultiselect.indexOf(element) < 0) {
      newMultiselect.push(element)
      setMultiselectCohortes(newMultiselect)
    } else {
      let idx = newMultiselect.indexOf(element)
      newMultiselect.splice(idx, 1)
      setMultiselectCohortes(newMultiselect)
    }
  }

  if (
    cohortes === null ||
    fields === null ||
    tienePermisoEditarPagina === null
  ) {
    return <Loading />
  }

  return (
    <>
      {props.mostrarTotal && <p>{cohortes.length} cohortes encontrados</p>}
      <Table
        id={"table-" + props.view.key}
        className="detallesCohortes table-striped border-top border-bottom"
        size="sm"
      >
        <thead>
          <tr>
            {tienePermisoEditarPagina && (
              <th>
                <Form.Check
                  checked={multiselectCohortes.length === cohortes.length}
                  onChange={() => {
                    selectAllNone()
                  }}
                  title="Seleccionar/Deseleccionar todo"
                />
              </th>
            )}
            <th className="numero-cohorte">#</th>
            <th>Sigla</th>
            <th>
              <span className="d-none d-sm-block">Cohorte</span>
              <span className="d-sm-none">Coh</span>
            </th>
            {!props.ocultarId && <th>ID</th>}
            <th className="d-none">Maestro ID</th>
            {fields.map((field) => (
              <th key={field.key}>
                {field.titlemobile !== undefined && (
                  <div>
                    <span
                      className="d-none d-sm-block"
                      dangerouslySetInnerHTML={{ __html: field.Nombre }}
                    />
                    <span
                      className="d-sm-none"
                      dangerouslySetInnerHTML={{ __html: field.titlemobile }}
                    />
                  </div>
                )}
                {field.titlemobile === undefined && (
                  <span
                    className="d-block"
                    dangerouslySetInnerHTML={{ __html: field.Nombre }}
                  />
                )}
              </th>
            ))}
            <th className="check-cohorte">
              {multiselectCohortes.length > 1 && !props.deshabilitarMenu && (
                <MenuCohorte
                  cohortes={multiselectCohortes}
                  editarEnLinea={abrirEditarEnLinea}
                  permisoEditarPagina={tienePermisoEditarPagina}
                />
              )}
              {(multiselectCohortes.length === 0 || props.deshabilitarMenu) && (
                <span>&nbsp;</span>
              )}
            </th>
          </tr>
        </thead>
        <tbody>
          {cohortes.map((cohorte, idx) => {
            let idpostula = cohorte.esborrador ? cohorte.maestroid : cohorte.id
            let urledicion = cohorte.esborrador
              ? "/borrador/" + cohorte.maestroid
              : "/cohorte/" + cohorte.id
            if (props.urlEdicion) {
              urledicion = props.urlEdicion + idpostula
            }
            return (
              <tr
                key={idx + 1}
                className={
                  (multiselectCohortes.indexOf(cohorte.id) >= 0
                    ? "selected"
                    : "") +
                  (cohorte.esborrador && !props.borradores ? " borrador" : "")
                }
              >
                {tienePermisoEditarPagina && !cohorte.esborrador && (
                  <td className="check-cohorte">
                    <Form.Check
                      checked={
                        multiselectCohortes.indexOf(cohorte.id) >= 0
                          ? true
                          : false
                      }
                      onChange={() => {
                        cohorteSelected(cohorte.id)
                      }}
                    />
                  </td>
                )}
                {tienePermisoEditarPagina && cohorte.esborrador && (
                  <td className="check-cohorte">-</td>
                )}
                <td>{idx + 1}</td>
                <td className="">
                  <Link to={urledicion}>{cohorte.sigla}</Link>
                </td>
                <td className="CohorteNombre">
                  <Link to={urledicion}>
                    <span className="d-none d-sm-block">{cohorte.nombre}</span>
                    <span className="d-sm-none">{cohorte.nombre}</span>
                  </Link>
                </td>
                {!props.ocultarId && (
                  <td className="CohorteId">
                    <Link to={urledicion}>
                      {cohorte.esborrador ? "Borrador" : idpostula}
                    </Link>
                  </td>
                )}
                <td className="MaestroId d-none">
                  <Link to={urledicion}>{cohorte.MaestroId}</Link>
                </td>
                {fields.map((field) => {
                  let _value = cohorte[field.key]
                  let _esPendiente =
                    _value === null ||
                    _value === undefined ||
                    _value.toString().trim() === ""
                  return (
                    <td
                      key={field.key}
                      style={
                        props.destacarPendiente && _esPendiente
                          ? styles["alert-danger"]
                          : {}
                      }
                    >
                      <Atributo
                        field={field}
                        cohorte={cohorte}
                        fullvalue={props.fullvalue}
                      />
                    </td>
                  )
                })}
                <td className="check-cohorte">
                  {!props.deshabilitarMenu && (
                    <MenuCohorte
                      cohorte={cohorte}
                      cohortes={multiselectCohortes}
                      editarEnLinea={abrirEditarEnLinea}
                      permisoEditarPagina={tienePermisoEditarPagina}
                    />
                  )}
                </td>
              </tr>
            )
          })}
        </tbody>
      </Table>
      <EditarCohorteModal
        isOpen={isOpenEditarEnLinea}
        cohortes={multiselectCohortes}
        cohorte={selectedCohorte}
        cerrar={cerrarEditarEnLinea}
        view={props.view}
      />
    </>
  )
}

export default ListadoCohortes
